<div class="section-dialog-cancel-app">
  
  <div class="content-dialog" >
    <h2 mat-dialog-title>{{ "CancelAppointment" | translate }}</h2>
    
    <mat-dialog-content class="mat-typography" *ngIf="!isDeleting">
      <p>{{ "AreYouSureToCancelYourReservation" | translate }}</p>
    </mat-dialog-content>

    <div *ngIf="isDeleting">
      <section class="dialog-loading-container">
        <div class="pulsing">
          <mat-spinner [diameter]="50"></mat-spinner>
        </div>
        <p class="dialog__loading-text">{{"Canceling" | translate}}</p>
      </section>

      
    </div>

  </div>

 

  <mat-dialog-actions align="center" *ngIf="!isDeleting">
    <div class="container-btn-reservation">
      <button
        mat-raised-button
        class="btn-reservation btn-accept"
        (click)="cancel()"
      >
        {{ "Back" | translate | uppercase}}
      </button>
      <button
        mat-raised-button
        class="btn-reservation"
        (click)="deleteServiceSchedule()"
        cdkFocusInitial
      >
        {{ "Next" | translate | uppercase }}
      </button>
    </div>
  </mat-dialog-actions>

</div>

